import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaLinkedin,
  FaPhoneAlt,
  FaEnvelope,
  FaChevronDown,
} from "react-icons/fa";
import { HiMenuAlt3, HiX } from "react-icons/hi";
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const socialLinks = {
    facebook: "https://www.facebook.com/ashamodernschool",
    twitter: "https://twitter.com/ashamodernschool",
    instagram: "https://www.instagram.com/ashamodernschool",
    youtube: "https://www.youtube.com/c/ashamodernschool",
    linkedin: "https://www.linkedin.com/school/asha-modern-school",
  };
  const navClass = ({ isActive }) =>
    `text-sm font-semibold transition ${
      isActive ? "text-red-600" : "text-gray-700 hover:text-red-600"
    }`;
  const dropdownClass =
    "block px-4 py-2 text-xs text-gray-700 hover:bg-red-50 hover:text-red-600 transition";
  return (
    <nav className="sticky top-0 z-50 bg-white shadow-lg">
      <div className="bg-gradient-to-r from-red-600 to-orange-500 text-white py-2">
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-2">
          <div className="flex flex-wrap items-center gap-4 text-xs">
            <div className="flex items-center gap-2">
              <FaEnvelope />
              <span>info@ashamodernschool.com</span>
            </div>
            <div className="flex items-center gap-2">
              <FaPhoneAlt />
              <span>+91-9839961911</span>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <a href={socialLinks.facebook} target="_blank" rel="noreferrer">
              <FaFacebook className="hover:scale-110 transition" />
            </a>
            <a href={socialLinks.twitter} target="_blank" rel="noreferrer">
              <FaTwitter className="hover:scale-110 transition" />
            </a>
            <a href={socialLinks.instagram} target="_blank" rel="noreferrer">
              <FaInstagram className="hover:scale-110 transition" />
            </a>
            <a href={socialLinks.youtube} target="_blank" rel="noreferrer">
              <FaYoutube className="hover:scale-110 transition" />
            </a>
            <a href={socialLinks.linkedin} target="_blank" rel="noreferrer">
              <FaLinkedin className="hover:scale-110 transition" />
            </a>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center gap-3">
            <img
              src="/logo.png"
              alt="Asha Modern School"
              className="h-12 w-auto object-contain"
            />
          </Link>
          <div className="hidden lg:flex items-center gap-5">
            <NavLink to="/" className={navClass}>
              Home
            </NavLink>
            <div className="relative group">
              <button className="text-sm font-semibold text-gray-700 hover:text-red-600 flex items-center gap-1 transition">
                About
                <FaChevronDown size={10} />
              </button>
              <div className="absolute left-0 top-full pt-3 hidden group-hover:block z-50">
                <div className="w-52 bg-white rounded-xl shadow-xl border border-orange-100 overflow-hidden">
                  <Link to="/about-school" className={dropdownClass}>
                    About The School
                  </Link>
                  <Link to="/administration" className={dropdownClass}>
                    Our Administration
                  </Link>
                  <Link to="/rules-section" className={dropdownClass}>
                    Rules & Regulations
                  </Link>
                  <Link to="/chairman-message" className={dropdownClass}>
                    Chairman's Message
                  </Link>
                  <Link to="/principal-massage" className={dropdownClass}>
                    Principal Message
                  </Link>
                </div>
              </div>
            </div>
            <div className="relative group">
              <button className="text-sm font-semibold text-gray-700 hover:text-red-600 flex items-center gap-1 transition">
                Campus
                <FaChevronDown size={10} />
              </button>
              <div className="absolute left-0 top-full pt-3 hidden group-hover:block z-50">
                <div className="w-44 bg-white rounded-xl shadow-xl border border-orange-100 overflow-hidden">
                  <Link to="/campus-overview" className={dropdownClass}>
                    Campus Overview
                  </Link>
                  <Link to="/infrastructure" className={dropdownClass}>
                    Infrastructure
                  </Link>
                  <Link to="/cafeteria" className={dropdownClass}>
                    Cafeteria
                  </Link>
                </div>
              </div>
            </div>
            <NavLink to="/fee-structure" className={navClass}>
              Fee Structure
            </NavLink>
            <NavLink to="/faculty" className={navClass}>
              Faculty
            </NavLink>
            <div className="relative group">
              <button className="text-sm font-semibold text-gray-700 hover:text-red-600 flex items-center gap-1 transition">
                Admission
                <FaChevronDown size={10} />
              </button>
              <div className="absolute left-0 top-full pt-3 hidden group-hover:block z-50">
                <div className="w-52 bg-white rounded-xl shadow-xl border border-orange-100 overflow-hidden">
                  <Link to="/admission-procedure" className={dropdownClass}>
                    Admission Procedure
                  </Link>
                  <Link to="/student-documents" className={dropdownClass}>
                    Student Document
                  </Link>
                </div>
              </div>
            </div>
            <div className="relative group">
              <button className="text-sm font-semibold text-gray-700 hover:text-red-600 flex items-center gap-1 transition">
                Gallery
                <FaChevronDown size={10} />
              </button>
              <div className="absolute left-0 top-full pt-3 hidden group-hover:block z-50">
                <div className="w-44 bg-white rounded-xl shadow-xl border border-orange-100 overflow-hidden">
                  <Link to="/gallery" className={dropdownClass}>
                    School Gallery
                  </Link>
                  <Link to="/video-gallery" className={dropdownClass}>
                    Video Gallery
                  </Link>
                </div>
              </div>
            </div>
            <NavLink to="/news" className={navClass}>
              News
            </NavLink>
            <NavLink to="/contact" className={navClass}>
              Contact Us
            </NavLink>
            <Link to="/enquiry-form">
              <button className="px-5 py-2.5 bg-gradient-to-r from-red-600 to-orange-500 text-white rounded-xl text-sm font-bold shadow-md hover:shadow-xl hover:scale-105 transition-all duration-300">
                Enquiry Form
              </button>
            </Link>
          </div>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden text-gray-700"
          >
            {isOpen ? <HiX size={28} /> : <HiMenuAlt3 size={28} />}
          </button>
        </div>
        {isOpen && (
          <div className="lg:hidden mt-4 border-t pt-4 pb-4 space-y-2">
            <NavLink to="/" className="block text-sm font-medium text-gray-700 py-1.5">
              Home
            </NavLink>
            <button
              onClick={() =>
                setOpenDropdown(openDropdown === "about" ? null : "about")
              }
              className="w-full flex justify-between items-center text-sm font-medium text-gray-700 py-1.5"
            >
              About
              <FaChevronDown
                size={10}
                className={`transition ${
                  openDropdown === "about" ? "rotate-180" : ""
                }`}
              />
            </button>
            {openDropdown === "about" && (
              <div className="pl-4 space-y-1">
                <Link to="/about-school" className="block text-xs text-gray-600 py-1">
                  About The School
                </Link>
                <Link to="/administration" className="block text-xs text-gray-600 py-1">
                  Our Administration
                </Link>
                <Link to="/rules-regulations" className="block text-xs text-gray-600 py-1">
                  Rules & Regulations
                </Link>
                <Link to="/chairman-message" className="block text-xs text-gray-600 py-1">
                  Chairman's Message
                </Link>
                <Link to="/principal-message" className="block text-xs text-gray-600 py-1">
                  Principal Message
                </Link>
              </div>
            )}
            <button
              onClick={() =>
                setOpenDropdown(openDropdown === "campus" ? null : "campus")
              }
              className="w-full flex justify-between items-center text-sm font-medium text-gray-700 py-1.5"
            >
              Campus
              <FaChevronDown
                size={10}
                className={`transition ${
                  openDropdown === "campus" ? "rotate-180" : ""
                }`}
              />
            </button>
            {openDropdown === "campus" && (
              <div className="pl-4 space-y-1">
                <Link to="/campus" className="block text-xs text-gray-600 py-1">
                  Campus Overview
                </Link>
                <Link to="/infrastructure" className="block text-xs text-gray-600 py-1">
                  Infrastructure
                </Link>
                <Link to="/cafeteria" className="block text-xs text-gray-600 py-1">
                  Cafeteria
                </Link>
              </div>
            )}
            <NavLink to="/fee-structure" className="block text-sm font-medium text-gray-700 py-1.5">
              Fee Structure
            </NavLink>
            <NavLink to="/faculty" className="block text-sm font-medium text-gray-700 py-1.5">
              Faculty
            </NavLink>
            <button
              onClick={() =>
                setOpenDropdown(
                  openDropdown === "admission" ? null : "admission"
                )
              }
              className="w-full flex justify-between items-center text-sm font-medium text-gray-700 py-1.5"
            >
              Admission
              <FaChevronDown
                size={10}
                className={`transition ${
                  openDropdown === "admission" ? "rotate-180" : ""
                }`}
              />
            </button>
            {openDropdown === "admission" && (
              <div className="pl-4 space-y-1">
                <Link to="/admission-procedure" className="block text-xs text-gray-600 py-1">
                  Admission Procedure
                </Link>
                <Link to="/student-documents" className="block text-xs text-gray-600 py-1">
                  Student Document
                </Link>
              </div>
            )}
            <button
              onClick={() =>
                setOpenDropdown(openDropdown === "gallery" ? null : "gallery")
              }
              className="w-full flex justify-between items-center text-sm font-medium text-gray-700 py-1.5"
            >
              Gallery
              <FaChevronDown
                size={10}
                className={`transition ${
                  openDropdown === "gallery" ? "rotate-180" : ""
                }`}
              />
            </button>
            {openDropdown === "gallery" && (
              <div className="pl-4 space-y-1">
                <Link to="/school-gallery" className="block text-xs text-gray-600 py-1">
                  School Gallery
                </Link>
                <Link to="/video-gallery" className="block text-xs text-gray-600 py-1">
                  Video Gallery
                </Link>
              </div>
            )}
            <NavLink to="/news" className="block text-sm font-medium text-gray-700 py-1.5">
              News
            </NavLink>
            <NavLink to="/contact" className="block text-sm font-medium text-gray-700 py-1.5">
              Contact Us
            </NavLink>
            <Link to="/enquiry-form">
              <button className="w-full mt-3 px-5 py-3 bg-gradient-to-r from-red-600 to-orange-500 text-white rounded-xl text-sm font-bold">
                Enquiry Form
              </button>
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};
export default Navbar;